import { Typography } from '@material-ui/core';
import MBox from '@material-ui/core/Box/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';
import AdminButton from 'admin/AdminButton';
import { Box } from 'home/useBoxes';
import React from 'react';
import BoxListItem from './BoxListItem';

import { makeStyles, Theme } from '@material-ui/core/styles';

interface Props {
  boxes: Box[];
}

const NoBoxes = () => {
  return (
    <ListItem>
      <Typography align="center" style={{ width: '100%' }}>
        ボックスが登録していない
      </Typography>
    </ListItem>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  listContainer: { overflowY: 'auto' },
}));

const BoxList = ({ boxes }: Props) => {
  const classes = useStyles();

  return (
    <MBox className={classes.listContainer}>
      <List dense disablePadding>
        <ListItem>
          <ListItemText primary="ボックスリスト" />
          <ListItemSecondaryAction>
            <AdminButton />
          </ListItemSecondaryAction>
        </ListItem>
        {boxes.sort((a,b)=> a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map((box) => (
          <BoxListItem key={box.id} box={box} />
        ))}
        {boxes.length === 0 ? <NoBoxes /> : null}
      </List>
    </MBox>
  );
};

export default BoxList;
